import { render } from "./AppFaceId.vue?vue&type=template&id=2dc06fa4&scoped=true"
import script from "./AppFaceId.vue?vue&type=script&lang=js"
export * from "./AppFaceId.vue?vue&type=script&lang=js"

import "./AppFaceId.vue?vue&type=style&index=0&id=2dc06fa4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc06fa4"]])

export default __exports__